export default __webpack_public_path__ + "static/media/dots.c8e9dcce.svg";